module.exports = __webpack_public_path__ + "static/media/bs.cbc10545.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/bs.svg
// module id = 1001
// module chunks = 0